/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { EvaluationResultSchemaMatch } from './evaluationResultSchemaMatch';
import type { EvaluationResultSchemaStatus } from './evaluationResultSchemaStatus';
import type { EvidenceItem } from './evidenceItem';

export interface EvaluationResultSchema {
  criterion_id: string;
  criterion_version_at_eval: number;
  status: EvaluationResultSchemaStatus;
  match?: EvaluationResultSchemaMatch;
  reasoning?: string | null;
  evidence?: EvidenceItem[];
  confidence?: number | null;
}
